export default function () {   
   document.addEventListener('click', function(event) {
        const targetItem = event.target.closest('.faq-item');
        if (targetItem) {
            const question = targetItem.querySelector('.faq-question');
            const answer = targetItem.nextElementSibling;
            const svg = targetItem.querySelector('svg');

            const faqItems = document.querySelectorAll('.faq-item');

            faqItems.forEach(otherItem => {
                if (otherItem !== targetItem) {
                    const otherAnswer = otherItem.nextElementSibling;
                    const otherSvg = otherItem.querySelector('svg');

                    otherAnswer.classList.remove('active');
                    otherSvg.classList.remove('active');
                    otherAnswer.style.maxHeight = "0";
                    otherSvg.style.transform = "rotate(0deg)"; // Reset rotation of other SVGs
                }
            });

            answer.classList.toggle('active');
            svg.classList.toggle('active');

            // Toggle the class for the upward and downward arrow
            if (svg.classList.contains('active')) {
                svg.style.transform = "rotate(180deg)";
            } else {
                svg.style.transform = "rotate(0deg)";
            }

            if (answer.classList.contains('active')) {
                answer.style.maxHeight = answer.scrollHeight + "px";
            } else {
                answer.style.maxHeight = "0";
            }
        }
    });
}